import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = ['Frases y modelos listos para aplicar en el próximo cierre', 'Checklist de verificación por sección', 'Ejemplos reales adaptados al sistema educativo argentino', 'Glosario integrado con vocabulario pedagógico actualizado', 'Tablas de referencia rápida para usar mientras redactás', 'Plantillas editables en Word para personalizar', 'Sin tecnicismos innecesarios — entendés todo aunque seas docente novel', 'Optimizado para celular y tablet — lo abrís donde estés', 'Contexto 100% argentino — normativa vigente y lenguaje rioplatense', 'Edición 2026: información actualizada para el ciclo lectivo en curso'];
  return <section className="py-12 bg-black border-y border-violet-900/40" data-id="element-177">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-178">
        <h3 className="text-2xl font-bold text-center mb-10 text-white" data-id="element-179">
          ✅ Cada tomo incluye:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-180">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-zinc-900/50 transition-colors" data-id="element-181">
              <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-182" />
              <span className="text-zinc-100 font-medium text-[16px]" data-id="element-183">
                {item}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}